/* DIAMOND TITANIUM | Desktop and mobile jewelry photo navigation */
(function () {
  'use strict';

  function initializePhotoMenus() {
    document.querySelectorAll('[data-dtpm-root]').forEach(function (root) {
      // The Liquid snippet can load this script twice. Initialize each menu once.
      if (root.dataset.dtpmInitialized === 'yes') return;
      root.dataset.dtpmInitialized = 'yes';

      var desktop = root.querySelector('[data-dtpm-desktop]');
      if (desktop) {
        var trigger = desktop.querySelector('.dtpm-desktop__trigger');
        var panel = desktop.querySelector('[data-dtpm-panel]');
        var hoverTimer;

        function positionPanel() {
          if (!desktop.open || !trigger || !panel) return;
          var bottom = trigger.getBoundingClientRect().bottom;
          var width = Math.min(1160, window.innerWidth - 24);
          var left = Math.max(12, Math.round((window.innerWidth - width) / 2));
          panel.style.setProperty('--dtpm-top', Math.round(bottom + 6) + 'px');
          panel.style.setProperty('--dtpm-left', left + 'px');
        }

        desktop.addEventListener('toggle', positionPanel);
        window.addEventListener('resize', positionPanel, { passive: true });
        window.addEventListener('scroll', positionPanel, { passive: true });

        // Mouse users can hover. Touch and keyboard users can click the summary.
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          desktop.addEventListener('mouseenter', function () {
            clearTimeout(hoverTimer);
            desktop.open = true;
            positionPanel();
          });
          desktop.addEventListener('mouseleave', function () {
            clearTimeout(hoverTimer);
            hoverTimer = setTimeout(function () { desktop.open = false; }, 200);
          });
        }
        document.addEventListener('pointerdown', function (event) {
          if (desktop.open && !desktop.contains(event.target)) desktop.open = false;
        });
        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && desktop.open) {
            desktop.open = false;
            if (trigger) trigger.focus();
          }
        });
      }

      // Keep only one mobile category expanded at once.
      var list = root.querySelector('.dtpm-mobile__list');
      if (list) {
        list.addEventListener('toggle', function (event) {
          var opened = event.target;
          if (!opened.matches || !opened.matches('details.dtpm-mobile__details') || !opened.open) return;
          list.querySelectorAll('details.dtpm-mobile__details[open]').forEach(function (other) {
            if (other !== opened) other.open = false;
          });
        }, true);
      }

      // Use the custom Shopify theme's existing close button for its drawer.
      var closeButton = root.querySelector('[data-dtpm-close]');
      if (closeButton) {
        closeButton.addEventListener('click', function () {
          var drawer = root.closest('#drawer-nav') || root.closest('.drawer') || root.closest('details.menu-drawer-container');
          if (!drawer) return;
          var existingClose = drawer.querySelector('[data-close]:not([data-dtpm-close])');
          if (existingClose) {
            existingClose.click();
          } else if (drawer.tagName === 'DETAILS') {
            drawer.open = false;
          } else {
            drawer.hidden = true;
            var overlay = document.getElementById('overlay');
            if (overlay) overlay.hidden = true;
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePhotoMenus);
  } else {
    initializePhotoMenus();
  }
  document.addEventListener('shopify:section:load', initializePhotoMenus);
})();
